import React from "react";
import { IoSettingsSharp } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";

const tabs = [
    { name: "KYC", path: "/settings" },
    { name: "Bank Details", path: "/sellerprufdetails" },
    { name: "Legal Entity (For Invoicing)", path: "/sellergst" },
    // { name: "Agreement", path: "/settings/agreement" },
    { name: " Label format", path: "/labelsetting" },
];

const SettingsHeader = ({ data }) => {
    const location = useLocation();

    return (
        <div className="px-6 pt-6 pb-6 bg-white rounded-lg">
            {/* Header */}
            <div className="flex items-center gap-2 text-gray-700">
                <IoSettingsSharp className="text-2xl text-gray-600" />
                <h2 className="text-xl font-bold">Settings {data ? `(${data})` : ""}</h2>
            </div>

            {/* Tabs */}
            <div className="mt-4 flex flex-wrap gap-2 border-b">
                {tabs.map((tab) => {
                    const isActive =
                        location.pathname === "/settings" // Default to KYC when on /settings
                            ? tab.path === "/settings"
                            : location.pathname.startsWith(tab.path);

                    return (
                        <Link
                            key={tab.name}
                            to={tab.path}
                            className={`px-4 py-2 text-sm relative transition-all duration-200 ${isActive
                                ? "font-semibold text-black bg-slate-50 after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-black"
                                : "text-gray-600 hover:text-black"
                                }`}
                        >
                            {tab.name}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default SettingsHeader;
